import React from 'react';
import { PageTitleWithToolTip } from '../../Common';
import { Grid, Paper } from '@mui/material';
import { paperResponsiveStyle } from './styles';

const SystemFilterBar = ({ title = "Filters", children }) => (
    <Paper variant="outlined" sx={{ ...paperResponsiveStyle }}>
        <Grid container spacing={2}>
            <Grid item xs={12} mt={2}>
                <PageTitleWithToolTip pageTitle={title} />
            </Grid>
            {children}
        </Grid>
    </Paper>
);

export default SystemFilterBar;
